import { withPrefetchedData } from '#src/shared/prefetch';

import { usePetitionUpdatePageData } from '#src/app/pages/petitionUpdate/details/pageContext';
import { MembershipAwarenessSunrise } from '#src/app/shared/components/membershipAwareness';

export const PageMembershipAwareness = withPrefetchedData(
	() => {
		const {
			data: {
				update: {
					petition: { id: petitionId, slug },
				},
				petitionSigned,
			},
		} = usePetitionUpdatePageData();

		return (
			<MembershipAwarenessSunrise
				sourceLocation="petition_update"
				petitionId={petitionId}
				slug={slug}
				signed={petitionSigned}
			/>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchDependencies: [MembershipAwarenessSunrise],
	},
);
